import { Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import * as ActionsList from './actions';
import { map, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { createEffect } from '@ngrx/effects';
import { AccountsService } from 'src/app/services/accounts.service';
import { ToastrService } from 'ngx-toastr';
import { WebUserService } from 'src/app/services/webuser.service';

@Injectable()
export class ForgotPasswordEffects {
  constructor(private store: Store<any>,
    public toastr: ToastrService,
    private actions$: Actions,
    private router: Router,
    private service: WebUserService) {
  }

  submit$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.SubmitRequestAction),
    switchMap((action: any) => this.service.forgotpassword(action.payload)),
    map((data: any) => {
      this.router.navigate(['login']);
      this.toastr.success(data.message);
      return ActionsList.SubmitResponseAction();
    })
  ));
}
